<template>
  <div class=" ml-3 mr-3">
    <b-form-group label="" class="mt-2">
      <b-form-row class="mt-1"
        ><b-col class="col-md-12"
          ><b-btn
            :disabled="searchResultsLoading"
            @click="toggleSearchMode('point')"
            variant="primary"
            :class="{ 'col-md-12': true, 'mode-active': searchModuleByPoint }"
            size="sm"
          >
            <span v-if="!searchResultsLoading">Wyszukiwanie kołem</span>
            <span v-else
              ><icon name="circle-notch" spin></icon></span></b-btn></b-col
        ><b-col class="mt-1"
          >Promień koła wyszukiwania<b-select
            v-model="selectedSearchByGeometryRadius"
          >
            <option
              v-for="radius in radiuses"
              :value="radius.value"
              :key="radius.value"
            >
              {{ radius.text }}
            </option>
          </b-select></b-col
        >
      </b-form-row>
      <b-form-row class="mt-4"
        ><b-col class="col-md-12"
          ><b-btn
            :disabled="searchResultsLoading"
            @click="toggleSearchMode('rectangle')"
            variant="primary"
            :class="{
              'col-md-12': true,
              'mode-active': searchModuleByRectangle
            }"
            size="sm"
            ><span v-if="!searchResultsLoading">Wyszukiwanie prostokątem</span>
            <span v-else><icon name="circle-notch" spin></icon></span></b-btn
        ></b-col>
      </b-form-row>
      <b-form-row class="mt-1"
        ><b-col class="col-md-12"
          ><b-btn
            :disabled="searchResultsLoading"
            @click="toggleSearchMode('polygon')"
            variant="primary"
            :class="{
              'col-md-12': true,
              'mode-active': searchModuleByPolygon
            }"
            size="sm"
            ><span v-if="!searchResultsLoading">Wyszukiwanie wielokątem</span>
            <span v-else><icon name="circle-notch" spin></icon></span></b-btn
        ></b-col>
      </b-form-row>
      <b-form-row
        ><b-col
          ><b-btn
            @click="toggleSearchMode(null)"
            variant="primary"
            class="col-md-12 mt-4"
            size="sm"
            >Anuluj wyszukiwanie geometrią</b-btn
          ></b-col
        >
      </b-form-row></b-form-group
    >
  </div>
</template>

<script>
import {
  SEARCH_ADDRESS_SET_GEOMETRY_SEARCH_RADIUS,
  SEARCH_MODE_BY_POINT_ENABLE,
  SEARCH_MODE_BY_RECTANGLE_ENABLE,
  SEARCH_MODE_BY_POLYGON_ENABLE,
  SEARCH_MODE_BY_GEOMETRY_DISABLE
} from '../../store/mutations.type';
import { mapGetters } from 'vuex';

export default {
  name: 'LayersSearch',
  data() {
    return {
      selectedSearchByGeometryRadius: 0,
      radiuses: [
        { text: '0m', value: 0 },
        { text: '100m', value: 0.1 },
        { text: '200m', value: 0.2 },
        { text: '300m', value: 0.3 },
        { text: '400m', value: 0.4 },
        { text: '500m', value: 0.5 }
      ]
    };
  },
  mounted() {},
  methods: {
    toggleSearchMode(mode) {
      switch (mode) {
        case 'point':
          this.$store.commit(SEARCH_MODE_BY_POINT_ENABLE, null);
          break;
        case 'rectangle':
          this.$store.commit(SEARCH_MODE_BY_RECTANGLE_ENABLE, null);
          break;
        case 'polygon':
          this.$store.commit(SEARCH_MODE_BY_POLYGON_ENABLE, null);
          break;
        case 'null':
          this.$store.commit(SEARCH_MODE_BY_GEOMETRY_DISABLE, null);
          break;
        default:
          this.$store.commit(SEARCH_MODE_BY_GEOMETRY_DISABLE, null);
          break;
      }
    }
  },
  watch: {
    selectedSearchByGeometryRadius() {
      this.$store.commit(
        SEARCH_ADDRESS_SET_GEOMETRY_SEARCH_RADIUS,
        this.selectedSearchByGeometryRadius
      );
    }
  },
  computed: {
    ...mapGetters([
      'searchModuleByPoint',
      'searchModuleByRectangle',
      'searchModuleByPolygon',
      'searchResultsLoading'
    ])
  }
};
</script>

<style scoped>
.mode-active {
  opacity: 0.65 !important;
}
</style>
